var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hik-video-plugin"},[_c('div',{staticClass:"hik-plugin-host",attrs:{"id":_vm.containerId}}),(_vm.opInfo)?_c('pre',{staticClass:"hik-video-log"},[_vm._v(_vm._s(_vm.opInfo))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }